import React from 'react';
import { Users } from 'lucide-react';
export function TrustBar() {
  return <section className="w-full bg-bg-dark py-6 border-y border-border-light px-4 relative overflow-hidden" data-id="element-215">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-center relative z-10" data-id="element-216">
        <div className="flex items-center gap-2 text-primary bg-white px-4 py-2 rounded-full border border-border-light shadow-sm" data-id="element-217">
          <Users className="w-5 h-5" data-id="element-218" />
        </div>
        <p className="text-text-sec text-base sm:text-lg font-medium" data-id="element-219">
          La risorsa scelta da oltre{' '}
          <span className="font-bold text-primary" data-id="element-220">1.000 docenti</span> in tutta
          Italia.
        </p>
      </div>
    </section>;
}